import React from "react";

export interface IToolbarContext {
    children: any;
    updateChildren: (children: any) => void;
}

export const ToolbarContext = React.createContext<IToolbarContext>({ children: "Hi", updateChildren: () => { /**/ } });

class ToolbarMenu extends React.Component {
    public render() {
        return (
            <ToolbarContext.Consumer>
                {ctx => <div className="menu-toolbar">{ctx.children}</div>}
            </ToolbarContext.Consumer>
        );
    }
}

export default ToolbarMenu;
